import { render, staticRenderFns } from "./querstionLook.vue?vue&type=template&id=8b70b482&scoped=true"
import script from "./querstionLook.vue?vue&type=script&lang=js"
export * from "./querstionLook.vue?vue&type=script&lang=js"
import style0 from "./querstionLook.vue?vue&type=style&index=0&id=8b70b482&prod&scoped=true&lang=scss"
import style1 from "./querstionLook.vue?vue&type=style&index=1&id=8b70b482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b70b482",
  null
  
)

export default component.exports